class BannerManager {
    constructor() {
        this.banners = [...document.querySelectorAll('.banner')];
        this.closedBannerKey = 'closedBanner';
        this.init();
    }

    init() {
        this.banners.forEach(banner => {
            const bannerId = banner.dataset.bannerId;
            if (!this.isBannerClosed(bannerId)) {
                this.showBanner(banner);
            } else {
                this.hideBanner(banner);
            }

            const closeBtn = banner.querySelector('.banner-close');
            if (closeBtn) {
                closeBtn.addEventListener('click', () => {
                    this.markBannerAsClosed(bannerId);
                    this.hideBanner(banner);
                });
            }
        });
    }

    isBannerClosed(bannerId) {
        const closedBanner = JSON.parse(localStorage.getItem(this.closedBannerKey)) || [];
        return closedBanner.includes(bannerId);
    }

    markBannerAsClosed(bannerId) {
        let closedBanner = JSON.parse(localStorage.getItem(this.closedBannerKey)) || [];
        if (!closedBanner.includes(bannerId)) {
            closedBanner.push(bannerId);
            localStorage.setItem(this.closedBannerKey, JSON.stringify(closedBanner));
        }
    }

    showBanner(banner) {
        banner.classList.remove('display-none');
    }

    hideBanner(banner) {
        banner.classList.add('display-none');
    }
}

new BannerManager();
